import { useEffect, useRef, useState } from "react";

const SYMBOLS = [
  { label: "BTC/USDT", value: "BINANCE:BTCUSDT" },
  { label: "ETH/USDT", value: "BINANCE:ETHUSDT" },
  { label: "XRP/USDT", value: "BINANCE:XRPUSDT" },
  { label: "BNB/USDT", value: "BINANCE:BNBUSDT" },
  { label: "SOL/USDT", value: "BINANCE:SOLUSDT" },
  { label: "DOGE/USDT", value: "BINANCE:DOGEUSDT" },
];

const MarketPage = () => {
  const containerRef = useRef(null);
  const [activeSymbol, setActiveSymbol] = useState(SYMBOLS[0].value);

  useEffect(() => {
    if (!containerRef.current) return;

    // Clear previous widget
    containerRef.current.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol: activeSymbol,
      interval: "D",
      timezone: "Etc/UTC",
      theme: "dark",
      style: "1",
      locale: "en",
      backgroundColor: "#0e1629",
      gridColor: "rgba(255, 255, 255, 0.04)",
      hide_top_toolbar: false,
      hide_legend: false,
      save_image: true,
      calendar: false,
      support_host: "https://www.tradingview.com",
    });

    containerRef.current.appendChild(script);
  }, [activeSymbol]);

  return (
    <div className="space-y-4 text-[15px]">

      {/* Header */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">Market</p>
          <h1 className="text-lg font-semibold text-slate-50">Live Charts</h1>
        </div>

        {/* Symbol tabs */}
        <div className="flex flex-wrap gap-2">
          {SYMBOLS.map((s) => (
            <button
              key={s.value}
              onClick={() => setActiveSymbol(s.value)}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold transition ${
                activeSymbol === s.value
                  ? "bg-emerald-500 text-slate-900"
                  : "bg-slate-800 text-slate-300 hover:bg-slate-700"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      {/* TradingView Chart */}
      <div
        className="rounded-2xl overflow-hidden border border-slate-800/80 bg-[#0e1629]"
        style={{ height: "600px" }}
      >
        <div
          className="tradingview-widget-container"
          ref={containerRef}
          style={{ height: "100%", width: "100%" }}
        >
          <div
            className="tradingview-widget-container__widget"
            style={{ height: "100%", width: "100%" }}
          />
        </div>
      </div>

    </div>
  );
};

export default MarketPage;